export enum TransferTypes {
    ERC20="ERC20",
    ERC721="ERC721"
}